'use client';

import { c as _c } from "react/compiler-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { useAppContext } from '@/app/_lib/_context';
const PromoSideTab = () => {
  const $ = _c(15);
  const {
    openPromoModal,
    dismissPromoTab
  } = useAppContext();
  let t0;
  if ($[0] !== openPromoModal) {
    t0 = () => {
      openPromoModal();
    };
    $[0] = openPromoModal;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClick = t0;
  let t1;
  if ($[2] !== dismissPromoTab) {
    t1 = e => {
      e.stopPropagation();
      dismissPromoTab();
    };
    $[2] = dismissPromoTab;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleDismiss = t1;
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FontAwesomeIcon icon={faHiveIconSmallLight} className="text-primary text-lg mb-3" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-xs font-medium text-ink-gray-bg whitespace-nowrap" style={{
      writingMode: "vertical-rl"
    }}>Save 10%</span>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== handleClick) {
    t4 = <button onClick={handleClick} className="flex flex-col items-center hover:opacity-80 transition-opacity" aria-label="Sign up for newsletter and save 10%">{t2}{t3}</button>;
    $[6] = handleClick;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="w-4 border-t border-gray-10 my-3" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <FontAwesomeIcon icon={faXmark} className="text-base" />;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== handleDismiss) {
    t7 = <button onClick={handleDismiss} className="text-ink-light-gray-bg hover:text-ink-gray-bg transition-colors" aria-label="Dismiss">{t6}</button>;
    $[10] = handleDismiss;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = <div className="fixed left-0 top-1/2 -translate-y-1/2 w-[2rem] bg-gray-4 rounded-r-md shadow-xl flex flex-col items-center py-2 z-[999]">{t4}{t5}{t7}</div>;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default PromoSideTab;